<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-8 col-6">
                    <h2>Profit and Loss </h2>
                     <div class="ims-tab ml-0">
                        <router-link 
                        :to="{ 
                          name: 'profitandlosslist', 
                          query: { traderId: $route.query.traderId, transactionType :this.$route.query.transactionType ,repCode :this.$route.query.repCode,fromdate :this.$route.query.fromdate,todate :this.$route.query.todate,isSettiled :this.$route.query.isSettiled, }}"  
                          class="inv-btn">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='profitandlosslist' }" >
                              Buys with sells
                          </button>
                        </router-link>
                        <router-link :to="{ name: 'profitandlossbuys', query: { traderId: $route.query.traderId, transactionType :this.$route.query.transactionType ,repCode :this.$route.query.repCode,fromdate :this.$route.query.fromdate,todate :this.$route.query.todate,isSettiled :this.$route.query.isSettiled, }}"  >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='profitandlossbuys' }" >
                              Buys
                          </button>
                        </router-link>
                        <router-link :to="{ name: 'profitandlosssells', query: { traderId: $route.query.traderId ,transactionType :this.$route.query.transactionType ,repCode :this.$route.query.repCode,fromdate :this.$route.query.fromdate,todate :this.$route.query.todate,isSettiled :this.$route.query.isSettiled, }}">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='profitandlosssells' }" >
                            Sells
                          </button>
                        </router-link>
                        <router-link :to="{ name: 'profitandlosstrademapping', query: { traderId: $route.query.traderId ,transactionType :this.$route.query.transactionType ,repCode :this.$route.query.repCode,fromdate :this.$route.query.fromdate,todate :this.$route.query.todate,isSettiled :this.$route.query.isSettiled, }}">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='profitandlosstrademapping' }" >
                            Trade Mapping
                          </button>
                        </router-link>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-12 col-8 text-right dashboard">
                      <!-- <div class="hint-parent" v-if="$route.name !='profitandlosstrademapping'">
                      <div class="hint-color">
                        <div>
                            <span class="min-denom-below" style="padding: 0;"><i class="fa fa-square-o"></i></span> 
                            <span class="hint" data-toggle="tooltip" data-placement="left"  title="Below Minimum Denomination">
                              <i class="fa fa-info-circle"></i>
                            </span>
                          </div>
                          <div>
                            <span class="min-denom-irregular" style="padding: 0;"><i class="fa fa-square-o"></i></span> 
                            <span class="hint" data-toggle="tooltip" data-placement="left"  title="Irregular Minimum Denomination ">
                              <i class="fa fa-info-circle"></i>
                            </span>
                          </div>
                          <div>
                            <span class="min-denom-both" style="padding: 0;"><i class="fa fa-square-o"></i></span> 
                            <span class="hint" data-toggle="tooltip" data-placement="left"  title="Below Minimum Denomination And Irregular Minimum Denomination ">
                              <i class="fa fa-info-circle"></i>
                            </span>
                          </div>
                        </div>
                      </div> -->
                    </div>
                </div>
                
            </div>
            
            </div>
        </div>
        <router-view></router-view>
        <plmodal
            v-if="plModalOpen"
            @close="closeImportPLModal()"
        ></plmodal>
    </div>      
</template>
<script>
import plmodal from "./ImsProfitLossImportModal";
export default {
  name: "imsPLComponentParent",
  components : {
      plmodal
  },
  data() {
    return {
        plModalOpen : false,
    };
  },
  methods: {
    openImportPLModal(){
        this.plModalOpen = true;
    },
    closeImportPLModal(){
        this.plModalOpen = false;
    }
  },
   mounted() {
     console.log("route",this.$route.query)
   }
};
</script>
<style scoped>
.hint-parent{
  background-color: #fff;
  border-radius: 9px;
  padding: 5px;
  position: absolute;
  right: 18px;

}
.hint-color { 
  display: flex;
  flex-direction: row;
}
.hint-color div {
  text-align: left;
  font-size: 17px;
  font-weight: 900;
}
.hint-color .hint {
 color: red
}
.hint-color i{
  color: #0087D4;
  font-size: 17px;
}
</style>